import React, { Component } from 'react';

class CheckoutFail extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			
		};
	}
	
	render() {
		const { name } = this.state;
		
		return (
			<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh'}}>
				<h2>Payment was failed!</h2>
			</div>
		);
	}
}

export default CheckoutFail